"use strict";
/** 
* Множественый выбор из справочника
* 
* @since 5.0.0.4106 
* @class WebAccess.components.forms.requisites.MultiSelect
* @param {string|WebAccess.components.forms.requisites.MultiSelect.multiSelectSettings} id Идентификатор элемента. Является обязательным параметром
* @param {string} referenceNames Коды справочников, разделенные символом ";"
* @param {string} [opt_toolTip] Высплывающая подсказка
* @param {string} [opt_searchReqName] Название отображаемого реквизита
* @param {string} [opt_filter] Выражение фильрации элементов выбранного справочника
* @param {boolean} [opt_isMultiSelect] Признак выбора одной или нескольких записей из нескольких справочников в диалоговом окне. Если установлено значение False, то можно выбрать только одну запись. Иначе доступен выбор несколько записей из нескольких справочников

* @property {string} id Идентификатор элемента. Является обязательным параметром
* @property {string} referenceNames Коды справочников, разделенные символом ";"
* @property {string} toolTip Всплывающая подсказка
* @property {string} searchReqName Название отображаемого реквизита
* @property {string} filter Выражение фильтрации элементов выбранного справочника
* @property {boolean} isMultiSelect Признак выбора одной или нескольких записей из нескольких справочников в диалоговом окне. Если установлено значение False, то можно выбрать только одну запись. Иначе доступен выбор несколько записей из нескольких справочников
* @property {string} html HTML-разметка элемента
*
* @fires render вызывается после того, как HTML-разметка собрана и готова к использованию.
* @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED - заданы не все обязатаельные параметры. 
*/

/** 
* Параметры множественного выбора из справочника.
* @typedef {object} WebAccess.components.forms.requisites.MultiSelect.multiSelectSettings
* @property {string} id  Идентификатор элемента. Является обязательным параметром
* @property {string} referenceNames Коды справочников, разделенные символом ";"
* @property {string} toolTip Всплывающая подсказка
* @property {string} searchReqName Название отображаемого реквизита
* @property {string} filter Выражение фильтрации элементов выбранного справочника
* @property {boolean} isMultiSelect Признак выбора одной или нескольких записей из нескольких справочников в диалоговом окне. Если установлено значение False, то можно выбрать только одну запись. Иначе доступен выбор несколько записей из нескольких справочников
* @property {string} html HTML-разметка элемента
*/
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

(function (global) {

  var MultiSelect = BaseObject.extend({
    init: function (id, referenceNames, opt_toolTip, opt_searchReqName, opt_filter, opt_isMultiSelect) {

      if (!id) WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED");

      this._super(id);
      if ($.isPlainObject(id)) {
        $.extend(this, id);
      } else {
        if (!referenceNames) WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED");
        this.id = id;
        this.referenceNames = !!referenceNames ? referenceNames : "ПОД";
        this.toolTip = !!opt_toolTip ? opt_toolTip : "";
        this.searchReqName = !!opt_searchReqName ? opt_searchReqName : "Наименование";
        this.filter = !!opt_filter ? opt_filter : "";
        this.isMultiSelect = !!opt_isMultiSelect ? opt_isMultiSelect : false;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: "MultiSelect",
    id: "",
    referenceNames: "",
    toolTip: "",
    searchReqName: "Наименование",
    filter: "",
    isMultiSelect: false,
    html: "",
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Собрать HTML-разметку с учетом указанных данных.
    * @function WebAccess.components.forms.requisites.MultiSelect#render
    * @return {string} Сгенерированная HTML-разметка
    */
    render: function () {
      var result = "";
      var requestMap = {
        "ID": this.id.toLowerCase(),
        "RefNames": this.referenceNames,
        "ToolTip": this.toolTip,
        "SearchReqName": this.searchReqName,
        "Filter": this.filter,
        "IsMultiSelect": this.isMultiSelect
      };

      CallServiceSync("/Requisite.asmx/MultiSelectControl", requestMap, function (response) {
        if (response.Success) {
          result = response.Result.html;
        }
        else ShowMessage(response.Result);
      });

      this.fire("render");
      this.html = result;
      return result;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.MultiSelect = MultiSelect;
})(window.WebAccess.components.forms.requisites);